import { Button } from "@radix-ui/themes";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useRouter } from "next/router";

import { AccountDropdown } from "../components/AccountDropdown";

import { AppSidebar } from "@/shadcn/components/app-sidebar";
import {
  SidebarProvider,
  SidebarTrigger,
} from "@/shadcn/ui/sidebar";
import { Bell } from "lucide-react";
import { useUser } from "../store/session";

export default function ShadLayout({ children }: any) {
  const location = useRouter();

  const { loading, user, fetchUserProfile } = useUser();


  const { t, lang } = useTranslation("nextmark");

  if (!user) {
    location.push("/auth/login");
  }

  if (location.pathname.includes("/admin") && user.isAdmin === false) {
    location.push("/");
    alert("You do not have the correct perms for that action.");
  }

  if (user && user.external_user) {
    location.push("/portal");
  }

  return (
    !loading &&
    user && (
      <div className="min-h-screen overflow-hidden">
        <SidebarProvider>
          <AppSidebar />
          <div className="w-full">
            <div className="sticky top-0 z-10 flex items-center px-4 border-b h-14 shrink-0 gap-x-4 bg-background sm:gap-x-6">
              <div className="flex items-center self-stretch flex-1 gap-x-4 lg:gap-x-6">
                <SidebarTrigger title="[" />
                <div className="sticky right-0 flex items-center justify-end w-full gap-x-2 lg:gap-x-2 ">
                  <Button
                    variant="outline"
                    className="relative p-2 text-gray-400 rounded-md hover:text-gray-500 hover:cursor-pointer focus:outline-none"
                  >
                    <Link href="/notifications">
                      <Bell className="w-4 h-4 text-foreground" />
                      {user.notifcations.filter(
                        (notification) => !notification.read
                      ).length > 0 && (
                        <svg
                          className="h-2.5 w-2.5 absolute bottom-6 left-6 animate-pulse fill-green-500"
                          viewBox="0 0 6 6"
                          aria-hidden="true"
                        >
                          <circle cx={3} cy={3} r={3} />
                        </svg>
                      )}
                    </Link>
                  </Button>

                  <AccountDropdown />
                </div>
              </div>
            </div>
            {!loading && !user.external_user && (
              <main className="min-h-screen bg-background">{children}</main>
            )}
          </div>
        </SidebarProvider>
      </div>
    )
  );
}
